import template from './user-details.html';
import UserSettings from '../../lib/UserSettings.js';

class ProfileUserDetailsTabComponentVM
{
	constructor(params)
	{
		this.vm = params.vm;
		this.username = ko.observable('');
		this.email = ko.observable('');
		this.enable_username_edit = ko.observable(false);
		this.enable_email_edit = ko.observable(false);
		this.user_settings = ko.observable();
		this.user_setting_list = ko.pureComputed(() => {
			if (this.user_settings())
				return this.user_settings().get_sorted_array();
			return [];
		});

		this.vm.register_tab_state('details', this);
		this.vm.user_data.subscribe((user) => {
			this.load_from_user(user);
		});
		if (this.vm.user_data())
			this.load_from_user(this.vm.user_data());
	}

	formatSettingName(name)
	{
		if (!name)
			return '';
		return name.replace(/_/g, ' ').replace(/^\w/, (character) => character.toUpperCase());
	}

	async load_user_settings_lookup ()
	{
		const settingsLookup = await Grape.cache.fetch('UserSettings');
		this.user_settings().set_settings(settingsLookup);

		const required_settings = [
			'fullnames',
			'family_name',
			'given_name',
			'picture',
			'delegation_code',
			'picture_filename',
			'delegation_expiry',
			'delegation_username',
			'theme',
			'locale',
			'theme_mode'
		];

		for (const setting_name of required_settings)
		{
			const setting = this.user_settings().get(setting_name);
			if (!setting)
			{
				this.user_settings().set_setting(setting_name, {
					active: true,
					idx: 999,
					tags: ['user_save'],
					value: ''
				});
			}
			else if (setting.value === undefined || setting.value === null)
				setting.value = '';
		}

		this.user_settings.notifySubscribers();
	}

	async load_from_user (user)
	{
		if (!user)
			return;
		this.username(user.username || '');
		this.email(user.email || '');
		this.enable_username_edit(false);
		this.enable_email_edit(false);

		const user_settings = new UserSettings(undefined, user.username);
		user_settings.set_values(user.settings || {});
		this.user_settings(user_settings);
		await this.load_user_settings_lookup();
	}

	get_save_data ()
	{
		const payload = {
			username: this.username(),
			email: this.email()
		};

		if (this.user_settings())
		{
			for (let [settingName, setting] of this.user_settings().entries())
				if (setting.tags.indexOf('user_save') > -1 && setting.input() != setting.value)
					payload[settingName] = setting.input();
		}

		return payload;
	}
}

export default {
	name: 'profile-user-details-tab',
	viewModel: ProfileUserDetailsTabComponentVM,
	module_type: 'ko',
	template: template
};
